module.exports = __webpack_public_path__ + "static/media/undraw_hacker_mindset_gjwq.d942b01a.svg";